// Generated from App.tsx for a single page build. Do not edit.
// Generated by the server from the registered pages. Do not edit.
import { Routes, Route, useLocation } from 'react-router-dom';
import HowToChooseCheckeredPlatePage from "../pages/HowToChooseCheckeredPlate/HowToChooseCheckeredPlate";
const __wvcRoutePaths = ["/HowToChooseCheckeredPlatePage", "/how-to-choose-checkered-plate"];
function AppRoutes() {
  const location = useLocation();
  const owned = new Set(["404", "about-us", "aboutuspage", "ansi-standards", "ansistandardspage", "applications", "applicationspage", "architecture-building", "architectureandbuildingpage", "articles-insights", "articlesinsightspage", "astm-standards", "astmstandardspage", "bar-grating", "bar-grating-installation", "bar-grating-specifications", "bargratinginstallationpage", "bargratingpage", "bargratingspecificationspage", "base-materials", "basematerialspage", "capabilities", "capabilitiespage", "checkered-plate", "checkered-plate-specifications", "checkeredplatepage", "checkeredplatespecificationspage", "contact", "contactpage", "crocodile-mouth-anti-slip-plate", "crocodilemouthantislipplatepage", "custom-oem-support", "customandoemsupportpage", "decorative-architectural-perforated-metal", "decorativearchitecturalperforatedmetalpage", "diamond-checkered-plate", "diamondcheckeredplatepage", "en-standards", "energy-utilities", "energyandutilitiespage", "engineering-calculations", "engineeringandcalculationspage", "enstandardspage", "expanded-metal", "expanded-metal-grating", "expanded-metal-specifications", "expandedmetalgratingpage", "expandedmetalpage", "expandedmetalspecificationspage", "filtration-process-equipment", "filtrationprocessequipmentpage", "finishes-coatings", "finishescoatingspage", "fish-eye-anti-slip-plate", "fisheyeantislipplatepage", "five-bar-checkered-plate", "fivebarcheckeredplatepage", "flattened-expanded-metal", "flattenedexpandedmetalpage", "gb-standards", "gbstandardspage", "glossary", "glossarypage", "home", "homepage", "how-to-choose-bar-grating", "how-to-choose-checkered-plate", "how-to-choose-expanded-metal", "how-to-choose-perforated-metal", "howtochoosebargratingpage", "howtochoosecheckeredplatepage", "howtochooseexpandedmetalpage", "howtochooseperforatedmetalpage", "industrial-manufacturing", "industrialmanufacturingpage", "infrastructure-transportation", "infrastructureandtransportationpage", "inspection-logistics", "inspectionlogisticspage", "installation-maintenance", "installationmaintenancepage", "iso-standards", "isostandardspage", "materials-finishes", "materialsfinishespage", "metal-panel-installation", "metalpanelinstallationpage", "our-hometown", "ourhometownpage", "perforated-metal", "perforated-metal-specifications", "perforated-vs-expanded-metal", "perforatedmetalpage", "perforatedmetalspecificationspage", "perforatedvsexpandedmetalpage", "post", "press-locked-bar-grating", "presslockedbargratingpage", "privacy-policy", "privacypolicypage", "product-specifications", "products", "productspage", "productspecificationspage", "quality-assurance", "quality-service", "qualityassurancepage", "qualityservicepage", "riveted-bar-grating", "rivetedbargratingpage", "round-hole-perforated-metal", "round-vs-square-perforated-metal", "roundholeperforatedmetalpage", "roundvssquareperforatedmetalpage", "search", "security-safety", "securityandsafetypage", "selection-design-guides", "selectiondesignguidespage", "site-map", "sitemappage", "slotted-hole-perforated-metal", "slottedholeperforatedmetalpage", "square-hole-perforated-metal", "squareholeperforatedmetalpage", "stair-tread-installation", "stair-treads", "stairtreadinstallationpage", "stairtreadspage", "standard-expanded-metal", "standardexpandedmetalpage", "standards-compliance", "standards-map", "standardsandcompliancepage", "standardsmappage", "supply-chain-sourcing", "supplychainandsourcingpage", "technical-resources", "technicalresourcespage", "two-bar-checkered-plate", "twobarcheckeredplatepage", "welded-bar-grating", "welded-vs-press-locked-bar-grating", "weldedbargratingpage", "weldedvspresslockedbargratingpage"]);
  const segment = (location.pathname.split('/')[1] || '').toLowerCase();
  return <Routes key={owned.has(segment) ? segment : '/'}>
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      <Route path={__wvcRoutePaths[0]} element={<HowToChooseCheckeredPlatePage />} />
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      <Route path={__wvcRoutePaths[1]} element={<HowToChooseCheckeredPlatePage />} />
      
      
    </Routes>;
}
function App() {
  return <>
      <AppRoutes />
    </>;
}
export default App;
